module.exports = __webpack_public_path__ + "static/img/phone1.defde2dd.png";